import { toast } from "sonner";
import api from "@/lib/api";

const STRIP = ["approval_token", "approval_status", "added_by_admin", "id"];

export const cleanItem = (it) => {
  const copy = { ...it };
  STRIP.forEach((k) => delete copy[k]);
  return copy;
};

export async function reorderItems(items, addItem, setDrawerOpen) {
  let results = items.map(() => ({ ok: true }));
  try { results = (await api.post("/orders/reorder-check", { items })).data.results; }
  catch { /* fall back to adding everything */ }
  const skipped = [];
  let added = 0;
  items.forEach((it, i) => {
    if (results[i]?.ok) { addItem(cleanItem(it)); added += 1; }
    else skipped.push(`${it.name} — ${results[i]?.reason || "unavailable"}`);
  });
  if (added) { setDrawerOpen(true); toast.success(`${added} item${added === 1 ? "" : "s"} added to cart`); }
  if (skipped.length) toast.warning(`Skipped ${skipped.length}: ${skipped.join("; ")}`, { duration: 7000 });
  if (!added && !skipped.length) toast.error("Nothing to reorder");
}
